const config = {
  API_URL: 'https://iam-sso-west-eur-hfdpfhefgzd6g7gm.westeurope-01.azurewebsites.net/v1',
  
  // Google OAuth Client IDs by hostname
  GOOGLE_OAUTH_CLIENTS: {
    'iam.salsa-bit.com': '1099160316842-79nvb05j0g0hq2goeleacld8ei49l1ee.apps.googleusercontent.com',
    'iam.pelegoal.com': '995020583788-mmg6k77ujudpepr386gbolf360oke1tp.apps.googleusercontent.com',
    'localhost': '1099160316842-79nvb05j0g0hq2goeleacld8ei49l1ee.apps.googleusercontent.com', // For local development
    'iam.cliposts.com': '314306060338-6slc6uusrhbed0pqgnik48nilrlf31da.apps.googleusercontent.com'
  } as Record<string, string>,
};
 
export default config; 